<div class="flex flex-col">
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>{{data.input?.fieldName}}</mat-label>
      <input matInput placeholder="" [(ngModel)]="data.input.name"
             required>
    </mat-form-field>
  </div>
  <div style="position: relative" class="editor-container w-p-100 flex flex-col full-grow-no-shrink-no-basis">
    <!--    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">-->
    <!--      <mat-label>Details</mat-label>-->
    <!--      <input matInput placeholder="Input" style="display: none"-->
    <!--             particleAnalytics-->
    <!--             analyticsCategory= "choice-filter-modal-item-editor"-->
    <!--             analyticsAction= "entity-scope-input">-->
    <!--      <ckeditor [ngModelOptions]="{standalone: true}"-->
    <!--                [(ngModel)]="data.input.description"-->
    <!--                [editor]="Editor"-->
    <!--                [disabled]="false"-->
    <!--                debounce="500">-->
    <!--      </ckeditor>-->
    <!--    </mat-form-field>-->
    <quill-editor [style]="{display: 'flex'}" [modules]="modules" [(ngModel)]="data.input.description"
                  [placeholder]="'Details'"></quill-editor>


    <!--    <button class="rest-btn"  matTooltip="Reset">-->
    <!--      <i class="far fa-sync-alt"></i>-->
    <!--    </button>-->
  </div>
</div>


